module.exports = __webpack_public_path__ + "media/attorney_resource_center/attorney-guide-book-center-79870346.png";